import { render } from "./DatosMenor.vue?vue&type=template&id=19e6eff2&ts=true"
import script from "./DatosMenor.vue?vue&type=script&lang=ts"
export * from "./DatosMenor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__